import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ARPage from "./pages/ARPage";
import VolcanesPage from "./pages/VolcanesPage";
import MapaChilePage from "./pages/MapaChilePage";
import MapScanPage from "./pages/MapScanPage";

function App() {
  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/ar" element={<ARPage />} />
        <Route path="/volcanes" element={<VolcanesPage />} />
        <Route path="/MapaChilePage" element={<MapaChilePage />} />
        <Route path="/scan-mapa" element={<MapScanPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
